import ValidationInterface from "@/plans/common/validation-interface";
import {
  basicPlusCategories,
  meetingCategories,
  SDKCategories,
  SDKUCCategories,
} from "@/common/persist-cart/categories";

export default class extends ValidationInterface {
  async requires() {
    return [];
  }

  async conflicts() {
    return this.current(basicPlusCategories).conflict(
      [...meetingCategories, ...basicPlusCategories, ...SDKCategories, ...SDKUCCategories]
    );
  }
}
